import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';
import { NumberValidatorDirective } from '@form-field-module/common/directives/number-validator.directive';

@Component({
    selector: 'sb-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, FormFieldLabelComponent, NumberValidatorDirective],
})
export class NumberInputComponent implements OnInit {
    @Input() formField: Field | ClientField;

    placeholder: string;
    maxLength: number;
    minLength: number;

    constructor(public formService: FormService) {}

    ngOnInit(): void {
        if (this.formField.value || this.formField.value === 0) {
            this.formField.value = this.formField.value.toString().replace(/,/g, '.');
        }

        this.maxLength = +this.formField.options?.maxNumber || Number.MAX_VALUE;
        this.minLength = +this.formField.options?.minNumber || 0;

        if (this.formField.value && this.formField.value.length > this.maxLength) {
            this.formField.value = this.formField.value.slice(0, this.maxLength);
        }
    }

    onPaste(event: ClipboardEvent): void {
        const pastedData = event.clipboardData?.getData('text') || '';
        this.preventPastingNotNumberValue(pastedData, event);
    }

    onDrop(event: DragEvent): void {
        const pastedData = event.dataTransfer?.getData('text') || '';
        this.preventPastingNotNumberValue(pastedData, event);
    }

    onInput(input: HTMLInputElement): void {
        input.value = input.value.replace(/,/g, '.');
        if (input.value.length > this.maxLength) {
            input.value = input.value.slice(0, this.maxLength);
        }
        this.formField.value = input.value;
    }

    onKeyDown(event: KeyboardEvent): void {
        if (!HelperService.isKeyAllowedForNumberField(event)) {
            this.preventPastingNotNumberValue(event.key, event);
        }
    }

    private preventPastingNotNumberValue(testedValue: string, event: Event): void {
        if (!/^[\d,e.+-]+$/.test(testedValue)) {
            event.preventDefault();
        }
    }
}
